// extracted by mini-css-extract-plugin
export var article_card = "FeaturedArticleCard-module--article_card--RQn-x";
export var article_thumbnail = "FeaturedArticleCard-module--article_thumbnail--ONVcq";
export var article_details = "FeaturedArticleCard-module--article_details--FytvL";
export var article_title = "FeaturedArticleCard-module--article_title--22d+c";
export var article_date = "FeaturedArticleCard-module--article_date--OFBJ6";